/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "../styles/main.scss"
import "../styles/loading.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <script src="https://static.airtable.com/js/embed/embed_snippet_v1.js"></script>
      <Header siteTitle={data.site.siteMetadata.title} />
      {children}
      <footer className="footer">
        <div className="content has-text-right">
          <p>
            A collaboration between <a href="https://texashousers.org/" target="_blank" rel="noopener noreferrer">
              Texas Housers Houston
            </a> and <a href="https://www.mokshadata.com/" target="_blank" rel="noopener noreferrer" className="moksha-brand"></a>.
          </p>
        </div>
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
